// Foundations
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

// rxjs
import { Observable } from 'rxjs';
import { map } from 'rxjs';

// Services
import { CognitoService } from '../services/cognito.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private cognitoService: CognitoService,
    private router: Router,
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.cognitoService.isSessionValid().pipe(map(isValid => {
      if (isValid) {
        return true;
      }
      this.router.navigate(['/welcome']);
      return false;
    }));
  }

}
